{
    "NAME": "LogboekinstellingenTaal",
    "LoggingSettings_Column_Component": "component",
    "LoggingSettings_Column_Enabled": "Ingeschakeld",
    "LoggingSettings_Column_BackupLogs": "Back-uplogboeken",
    "LoggingSettings_Column_Level": "Niveau",
    "LoggingSettings_Column_RollOverFiles": "Rollover-bestanden",
    "LoggingSettings_Column_MaxFileSizeAsMB": "Maximale bestandsgrootte (MB)",
    "LoggingSettings_Component_MainServlet": "Hoofdservlet",
    "LoggingSettings_Component_Database": "Database",
    "LoggingSettings_Component_Repository": "Opslagplaats",
    "LoggingSettings_Component_RptExecMgr": "Rapportuitvoeringsmanager",
    "LoggingSettings_Component_MailController": "Mailbeheerder",
    "LoggingSettings_Component_TaskDelegator": "Taakdelegator",
    "LoggingSettings_Component_TelephoneModule": "Telefoonmodule",
    "LoggingSettings_Component_OmniModule": "Omnichannel-module",
    "LoggingSettings_Action_Save": "Redden",
    "LoggingSettings_Action_Cancel": "Annuleren",
    "LoggingSettings_Action_Refresh": "Vernieuwen",
    "LoggingSettings_ReadOnlyWarning": "U beschikt niet over algemene beheerdersrechten om de logboekinstellingen bij te werken.",
    "LoggingSettings_SaveSuccess": "De logboekinstellingen zijn opgeslagen.",
    "LoggingSettings_SaveError": "Logboekinstellingen kunnen niet worden opgeslagen.",
    "LoggingSettings_RefreshConfirmTitle": "Niet-opgeslagen wijzigingen verwijderen?",
    "LoggingSettings_RefreshConfirmBody": "Door de pagina te vernieuwen worden uw niet-opgeslagen wijzigingen verwijderd. Doorgaan?",
    "LoggingSettings_Empty": "Er zijn geen logboekinstellingen beschikbaar."
}